module.exports = __webpack_public_path__ + "img/bg-partners-2.91a38f88.png";